<template>
  <div class="modal">
    <div
      class="modal__mask"
    >
      <div class="modal__content">
        <div class="modal__header">
          <div>
            叫號提醒設定
          </div>
        </div>
        <div class="modal__body">
          <div class=" fc--primary mb3 fs1 fw3">
            {{ theShift.division }} {{ theShift.room }}<br>
          </div>
          <div class=" fc--primary mb3 fs3 fw3">
            {{ theShift.doctor }} 醫師
          </div>
          <div class="row--central">
            <div class="circle circle--size-8 circle--secondary fs6 fw5">
              {{ theShift.currentNumber }}
            </div>
          </div>
          <div class=" fc--primary mt3">
            目前號碼
          </div>
        </div>
        <div class="pl3 align--left mb2">
          提醒設定
        </div>
        <select
          class="ba--primary align--center mb4"
          v-model="theReminder.enable"
        >
          <option :value="false">
            關閉
          </option>
          <option :value="true">
            開啟
          </option>
        </select>
        <div class="pl3 align--left mb2">
          提醒號碼
        </div>
        <select
          class="ba--primary align--center mb4"
          v-model="theReminder.number"
        >
          <option
            v-for="n in reminderNumbers"
            :value="n"
            :key="n"
          >
            {{ n }}
          </option>
        </select>
        <div class="modal__footer">
          <div
            class="label label--secondary"
            @click="$emit('close')"
          >
            關閉
          </div>
          <div
            class="label label--primary"
            @click="$emit('updateReminder')"
          >
            設定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    modelReminder: {
      type: Object,
      default() {
        return {};
      },
    },
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: [
    'close',
    'update:modelReminder',
    'updateReminder',
  ],
  setup(props, { emit }) {
    const theShift = computed({
      get: () => props.shift,
    });

    const theReminder = computed({
      get: () => props.modelReminder,
      set: (value) => emit('update:modelReminder', value),
    });

    // 計算目前可設定的提醒號碼
    const reminderNumbers = computed({
      get: () => {
        const numbers = [];
        if (theReminder.value.enable && theReminder.value.number
        && theReminder.value.number <= theShift.value.currentNumber) {
          numbers.push(theReminder.value.number);
        }
        for (let i = 1; i <= theShift.value.currentNumber + 100; i += 1) {
          if (i > theShift.value.currentNumber) numbers.push(i);
        }
        return numbers;
      },
    });

    return {
      theShift,
      theReminder,
      reminderNumbers,
    };
  },
};
</script>
